export const fontsAvenyt = [
  {
    style: "normal",
    urlSet: [
      {
        format: "woff2",
        url: "/fonts/AvenyT.woff2",
      },
      {
        format: "woff",
        url: "/fonts/AvenyT.woff",
      },
      {
        format: "truetype",
        url: "/fonts/AvenyT.ttf",
      },
      {
        format: "svg",
        url: "/fonts/AvenyT.svg#AvenyT",
      },
      {
        format: "embedded-opentype",
        url: "/fonts/AvenyT.eot?#iefix",
      },
    ],
    weight: "normal",
  },
];
